import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { ChevronDownIcon } from "../utils/IconFactory/index";
import { getMonths } from "./utils";
export function MonthSelector({ year, month, t, onMonthChange }) {
    const months = getMonths(t);
    return _jsxs(StyledMonth, { children: [_jsx(ChevronLeftIcon, { onClick: () => { onMonthChange('back'); } }), _jsxs(MonthYear, { children: [months[month], " ", year] }), _jsx(ChevronRightIcon, { onClick: () => { onMonthChange('forvard'); } })] });
}
const StyledMonth = styled.div `
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  user-select: none;

  & > svg{
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    user-select: none;
  }
`;
const MonthYear = styled.div `
  display: flex;
  justify-content: center;
      width: 80%;
`;
const ChevronLeftIcon = styled(ChevronDownIcon) `
  transform: rotate(90deg);
`;
const ChevronRightIcon = styled(ChevronDownIcon) `
  transform: rotate(-90deg);
`;
